import styled from '@emotion/styled';
import { Color } from '../../../styles/Color';
import { ContentWrap, Css, Shimmer } from '../../../ui';

export function SearchShimmer() {
	return (
		<StyledContentWrap>
			<CountTitleShimmer />

			<StyledList>
				<ListItemShimmer />
				<ListItemShimmer />
				<ListItemShimmer />
			</StyledList>
		</StyledContentWrap>
	);
}
function ListItemShimmer() {
	return (
		<ListItemWrap>
			<ListItemContentWrap>
				<TitleShimmer />
				<Snippet>
					<SnippetShimmerOne />
					<SnippetShimmerTwo />
				</Snippet>
			</ListItemContentWrap>
			<ReadMoreShimmer />
		</ListItemWrap>
	);
}

const StyledContentWrap = styled(ContentWrap)`
	width: 100%;
`;

const StyledList = styled.ul`
	list-style: none;
	padding: 0;
	margin: 0;
	padding: ${Css.pxToRem(24)} 0;
`;

const ListItemWrap = styled.div`
	padding: ${Css.pxToRem(16)} 0;
	border-bottom: 1px solid ${Color.Neutral92};
	display: flex;
	align-items: center;
	gap: ${Css.pxToRem(8)};
	text-decoration: none;
`;

const ListItemContentWrap = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: ${Css.pxToRem(12)};
`;

const StyledShimmer = styled(Shimmer)`
	background-color: ${Color.Neutral92};
	border-radius: ${Css.pxToRem(6)};
`;

const CountTitleShimmer = styled(StyledShimmer)`
	margin: ${Css.pxToRem(16)} 0;
	height: ${Css.pxToRem(40)};
	max-width: ${Css.pxToRem(320)};
`;

const TitleShimmer = styled(StyledShimmer)`
	width: ${Css.pxToRem(240)};
	height: ${Css.pxToRem(18)};
`;

const Snippet = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Css.pxToRem(8)};
`;
const SnippetShimmerOne = styled(StyledShimmer)`
	width: ${Css.pxToRem(550)};
	height: ${Css.pxToRem(16)};
`;

const SnippetShimmerTwo = styled(StyledShimmer)`
	width: ${Css.pxToRem(420)};
	height: ${Css.pxToRem(16)};
`;

const ReadMoreShimmer = styled(StyledShimmer)`
	width: ${Css.pxToRem(56)};
	height: ${Css.pxToRem(16)};
`;
